import { el } from "./dom";

/** A brief, auto-fading toast for transient summaries (e.g. a finished run). */
export function createToast(parent: HTMLElement): { show(text: string, ms?: number): void } {
  const node = el("div", { class: "toast" });
  Object.assign(node.style, {
    position: "fixed",
    bottom: "16px",
    left: "50%",
    transform: "translateX(-50%)",
    padding: "10px 16px",
    background: "#1c1c1c",
    border: "1px solid #444",
    borderRadius: "8px",
    color: "#eee",
    font: "13px system-ui, sans-serif",
    zIndex: "1000",
    opacity: "0",
    transition: "opacity .25s",
    pointerEvents: "none",
  });
  parent.append(node);

  let hideTimer = 0;
  return {
    show(text, ms = 4000) {
      window.clearTimeout(hideTimer);
      node.textContent = text;
      node.style.opacity = "1";
      hideTimer = window.setTimeout(() => {
        node.style.opacity = "0";
      }, ms);
    },
  };
}
